module.exports = __webpack_public_path__ + "../resources/img/bg_grid1_01.f6b9d4db.png";